<div
  class="footer-wrapper"
  [ngClass]="{'sidebar-enabled': isSidebarEnabled}"
>
  <div class="footer-holder">
    <app-footer-initial *ngIf="footerType === 'initial'"></app-footer-initial>
    <app-footer-second *ngIf="footerType === 'second'"></app-footer-second>
  </div>
</div>